<div
  class="tab-pane fade flex-even active show"
  id="sales"
  role="tabpanel"
  aria-labelledby="sales-tab"
  formGroupName="marketingFormGroup"
  >
  <div class="d-flex flex-column h-100">
    <div class="row mt-2">
      <div class="col-6 col-md">
        <div class="form-group row">
          <label class="col-4 col-form-label-sm" translate
            >CONTRACT_LBL_MARKETING_CAMPAIGN</label
            >
            <div class="col">
              <app-typeahead
                [entity]="Entity.Campaign"
                [routeEndpoint]="'Campaigns'"
                [pageSize]="30"
                [limitToList]="true"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get(
                  'marketingCampaignId'
                )
              "
              ></app-typeahead>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
              >CONTRACT_LBL_MARKETING_MEDIUM</label
              >
              <div class="col">
                <app-typeahead
                  [entity]="Entity.Medium"
                  [routeEndpoint]="'Mediums'"
                  [limitToList]="false"
                  [pageSize]="30"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get(
                  'marketingMediumId'
                )
              "
                ></app-typeahead>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label-sm" translate
                >CONTRACT_LBL_MARKETING_SOURCE</label
                >
                <div class="col">
                  <app-typeahead
                    [entity]="Entity.Source"
                    [routeEndpoint]="'Sources'"
                    [limitToList]="false"
                    [pageSize]="30"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get(
                  'marketingSourceId'
                )
              "
                  ></app-typeahead>
                </div>
              </div>
            </div>
            <div class="col-6 col-md">
              @if (this.isCampaignReferral) {
                <div class="form-group row">
                  <label class="col-4 col-form-label-sm" translate
                    >CONTRACT_LBL_MARKETING_REFERRER</label
                    >
                    <div class="col">
                      <app-typeahead
                        [routeEndpoint]="'Contacts'"
                        [entity]="Entity.Contact"
              [controlForm]="
                this.form.controls['marketingFormGroup'].get(
                  'marketingReferrerId'
                )
              "
                        [orderBy]="'name asc'"
                        [allowCustomActions]="true"
                        [limitToList]="true"
                        [placeholder]="'TYPEAHEAD_LBL_TYPE_TO_SEARCH_TEXT' | translate"
                      ></app-typeahead>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
